import { faTrashCan } from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";

import { EllipsisOptionsDropdown } from "src/base-components/OptionsDropdown/EllipsisOptionsDropdown";
import { Tooltip } from "src/design-system/Tooltip";

export enum ItemType {
  ACTION = "action",
  TASK = "task",
}

type TemplateListItemProps = {
  displayName: string | undefined;
  active: boolean;
  onRemove: () => void;
  onSelect: () => void;
  disabled?: boolean;
  itemType: ItemType;
};

export const TemplateListItem: React.FC<TemplateListItemProps> = ({
  active,
  displayName,
  onSelect,
  onRemove,
  disabled = false,
  itemType,
}) => {
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSelect();
    }
  };

  return (
    <li
      className={twJoin(
        "group",
        "cursor-pointer rounded-lg",
        "hover:bg-gray-50 data-[active=true]:bg-gray-100",
      )}
      data-active={active}
      data-loc="template-list-item"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={onKeyDown}
    >
      <span className="flex items-center justify-between px-2 py-1.5">
        <Tooltip delay={500} title={displayName || `(new ${itemType})`} asChild>
          <span className="truncate whitespace-nowrap font-inter-medium-13px text-gray-800">
            {displayName || `(new ${itemType})`}
          </span>
        </Tooltip>
        <span className="opacity-0 group-hover:opacity-100 group-focus:opacity-100">
          <EllipsisOptionsDropdown
            dataLoc="template-item-ellipsis"
            elements={[
              {
                key: `Delete ${itemType}`,
                action: onRemove,
                icon: faTrashCan,
                disabled,
              },
            ]}
            placement="bottom end"
          />
        </span>
      </span>
    </li>
  );
};

export const TemplateItemsList: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <ul
    className="mb-4 flex flex-col gap-y-2 bg-white py-0"
    data-loc="template-items-list"
  >
    {children}
  </ul>
);
